import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import About from './pages/About';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import Login from './pages/Login';
import ServicesPublic from './pages/ServicesPublic';
import ScrollToTop from './components/ScrollToTop';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminJobForm from './pages/admin/AdminJobForm';
import AdminAnnouncementForm from './pages/admin/AdminAnnouncementForm';
import AdminTestimonialForm from './pages/admin/AdminTestimonialForm';
import AdminRoute from './components/AdminRoute';
import CookieConsent from './components/CookieConsent';
import AnnouncementBanner from './components/AnnouncementBanner';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { ModalProvider } from './context/ModalContext';

// Public pages layout — wraps all non-admin pages with Navbar + Footer
function PublicLayout() {
    const location = useLocation();
    return (
        <div className="App">
            <Navbar />
            <div className="public-page-body">
                {location.pathname === '/' && <AnnouncementBanner />}
                <Outlet />
            </div>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <AdminAuthProvider>
            <ModalProvider>
                <Router>
                    <ScrollToTop />
                    <CookieConsent />
                    <Routes>
                        {/* ── Admin routes (no Navbar/Footer) ── */}
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={
                            <AdminRoute><AdminDashboard /></AdminRoute>
                        } />
                        <Route path="/admin/jobs/new" element={
                            <AdminRoute><AdminJobForm /></AdminRoute>
                        } />
                        <Route path="/admin/jobs/edit/:id" element={
                            <AdminRoute><AdminJobForm /></AdminRoute>
                        } />
                        <Route path="/admin/announcements/new" element={
                            <AdminRoute><AdminAnnouncementForm /></AdminRoute>
                        } />
                        <Route path="/admin/announcements/edit/:id" element={
                            <AdminRoute><AdminAnnouncementForm /></AdminRoute>
                        } />
                        <Route path="/admin/testimonials/new" element={
                            <AdminRoute><AdminTestimonialForm /></AdminRoute>
                        } />
                        <Route path="/admin/testimonials/edit/:id" element={
                            <AdminRoute><AdminTestimonialForm /></AdminRoute>
                        } />

                        {/* ── Public routes (with Navbar + Footer) ── */}
                        <Route element={<PublicLayout />}>
                            <Route path="/" element={<Homepage />} />
                            <Route path="/Homepage" element={<Homepage />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<ServicesPublic />} />
                            <Route path="/services/:serviceCode" element={<ServicesPublic />} />
                            <Route path="/careers" element={<Careers />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/contact" element={<Contact />} />
                        </Route>
                    </Routes>
                </Router>
            </ModalProvider>
        </AdminAuthProvider>
    );
}

export default App;
